import { Button, Container } from "react-bootstrap";
import styled from "styled-components";

export const ContainerLogin = styled(Container)`
  min-height: 100vh;
`;

export const ButtonLogin = styled(Button)`
    width: 100%;
    margin-top: 15px;
`;

export const ButtonEsqueci = styled(Button)`
    width: 100%;
    margin-top: 15px;
    text-align: left;
`;

export const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const DividerLine = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
`;

export const DividerLabel = styled.div`
  padding: 0 15px;
  color: #555;
`;